import { changedDraftBuses, changedDraftDirections, createTourDraft } from "./manualTourEditing";

// Shared by results and maps during navigation within the current login.
export const retainedDrafts = new Map();
export const draftWorkspaceKey = () => {
  let user = {};
  try { user = JSON.parse(localStorage.getItem("user")) || {}; } catch { /* Empty workspace. */ }
  return [localStorage.getItem("token"), user.planningMode || "OWN_FLEET", user.activeTenderWorkspace || 1].join(":");
};

export function pendingMapBusIds(result, workspaceKey) {
  const session = retainedDrafts.get(workspaceKey);
  if (!result || session?.data.result.completedAt !== result.completedAt) return [];
  return changedDraftBuses(session.draft, createTourDraft(session.data.result.tours));
}

export function pendingMapDirections(result, workspaceKey) {
  const session = retainedDrafts.get(workspaceKey);
  if (!result || session?.data.result.completedAt !== result.completedAt) return [];
  return changedDraftDirections(session.draft, createTourDraft(session.data.result.tours));
}
